import request from '@/utils/request';
import { GetRoundsResult, GetTypes2Result, GetTypesResult } from './types';

/**
 * 获取第一类别
 */
export const getTypes = async (date: string, locationCode: string): Promise<GetTypesResult> => {
  const { data } = await request({
    url: '/pickupTypes',
    method: 'get',
    params: { date, location_code: locationCode },
  });

  const convertType = (raw: any) => ({
    id: raw.id,
    date: raw.date,
    location_code: raw.location_code,
    not_completed_count: raw.not_completed_count,
    type_name: raw.type_name,
    type_no: raw.type_no,
  });

  return data.map(convertType);
};

/**
 * 获取第二类别
 */
export const getTypes2 = async (date: string, locationCode: string): Promise<GetTypes2Result> => {
  const { data } = await request({
    url: '/dn/type2',
    method: 'get',
    params: { date, location_codes: [locationCode] },
  });

  const convertType2 = (raw: any) => ({
    id: raw.id,
    date: raw.date,
    location_code: raw.location_code,
    type2: raw.type2,
  });

  return data.map(convertType2);
};

/**
 * 获取回合数
 */
export const getRounds = async (date: string, locationCode: string): Promise<GetRoundsResult> => {
  const { data } = await request({
    url: '/dn/rounds',
    method: 'get',
    params: { date, location_codes: [locationCode] },
  });

  const convertRound = (raw: any) => ({
    id: raw.id,
    date: raw.date,
    location_code: raw.location_code,
    round: raw.round,
  });

  return data.map(convertRound);
};

export const getProducts = (
  date: string,
  locationCode: string,
  type: string[],
  type2: string[],
  round: string,
) => request({
  url: '/dn/assigne/list',
  method: 'get',
  params: {
    date,
    location_codes: [locationCode],
    type,
    type2,
    round,
  },
});

export const assgin = (
  date: string,
  locationCode: string,
  itemNumbers: string[],
  beginDatetime: string,
  endDatetime: string,
) => request({
  url: '/dn/assigne',
  method: 'post',
  data: {
    date,
    location_codes: [locationCode],
    item_numbers: itemNumbers,
    begin_assign: beginDatetime,
    over_assign: endDatetime,
  },
});

export const unassgin = (date: string, locationCode: string, itemNumbers: string[]) => request({
  url: '/dn/cancel',
  method: 'post',
  data: {
    date,
    location_codes: [locationCode],
    item_numbers: itemNumbers,
  },
});

export const updateAnomalyStock = (
  date: string,
  locationCode: string,
  itemNumber: string,
  actualQty: string,
  type: string,
  comment = '',
) => request({
  url: '/anomalyStocks',
  method: 'post',
  data: {
    date,
    location_code: locationCode,
    item_number: itemNumber,
    actual_quantity: actualQty,
    type,
    comment,
  },
});

export const destroyAnomalyStock = (id: string) => request({
  url: `/anomalyStocks/${id}`,
  method: 'delete',
});
